<template>
  <div class="pro-section">
    <div class="grid grid--container">
      <div class="pro-section__content">
        <VText class="pro-section__title" variant="h2">Join the Pros</VText>
        <VText class="pro-section__text"
          >Create your best bio link with our Campsite.bio Pro subscription.
          Premium link types. Advanced analytics. Collaborators. We've got the
          tools to help you succeed.</VText
        >
        <Button
          size="large"
          color="secondary"
          variant="hard-shadow"
          v-bind="buttonAttrs"
          >{{ buttonText }}</Button
        >
      </div>

      <div class="pro-section__line" ref="line"></div>

      <div class="pro-section__features" ref="features">
        <span class="pill" v-for="feature in FEATURES" :key="feature">{{
          feature
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { VText, Button, useIsVisible } from '@campsite-bio/component-lib';
import { computed, ref, watch } from '@nuxtjs/composition-api';
import anime from 'animejs';

const FEATURES = [
  'Opt-in Forms',
  'Advanced Analytics',
  'Automated IG Grid',
  'Carousels',
  'Feeds',
  'Forms',
  'Collaborators',
  '3+ Profiles',
  'Hide Campsite Branding',
  'Subdomain',
  'Custom Domain',
  'Weekly Insights Email',
  'Make My Bio Link Wizard',
  'Priority Support',
  'Background Images',
  'Background Patterns',
  'Schedule Links',
  'Highlight a Link',
  'Meta Tags',
  'UTM Parameters',
];

export default {
  components: {
    VText,
    Button,
  },

  props: {
    buttonText: {
      type: String,
      default: 'Compare our Plans',
    },

    buttonUrl: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const line = ref(null);
    const features = ref(null);

    const buttonAttrs = computed(() => {
      if (props.buttonUrl) {
        return {
          href: props.buttonUrl,
        };
      }

      return {
        to: '/pricing',
      };
    });

    const isVisible = useIsVisible(line, {
      runOnce: true,
    });

    watch(isVisible, () => {
      const timeline = anime.timeline({
        easing: 'easeOutCubic',
        duration: 500,
      });

      timeline
        .add({
          targets: line.value,
          scaleY: [0, 1],
        })
        .add({
          targets: features.value.querySelectorAll('.pill'),
          opacity: [0, 1],
          scale: [0, 1],
          delay: anime.stagger(50),
        });
    });

    return { line, features, FEATURES, buttonAttrs };
  },
};
</script>

<style lang="scss" scoped>
.pro-section {
  padding-bottom: 4rem;
  padding-top: 3rem;
  text-align: center;

  @media (min-width: 992px) {
    padding-bottom: 8rem;
    padding-top: 7rem;
  }

  &__content {
    max-width: 625px;
    margin-left: auto;
    margin-right: auto;
  }

  &__features {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0.65rem;
    font-size: 1.75rem;
    line-height: 0;
  }

  &__line {
    background: var(--g-color-gray-500);
    width: 3px;
    height: 6rem;
    margin: 1rem auto;
    transform-origin: top center;
  }
}

.pro-section__title.pro-section__title {
  margin-bottom: 1.5rem;
  font-size: 2rem;

  @media (min-width: 768px) {
    font-size: 3.25rem;
  }
}

.pro-section__text.pro-section__text {
  font-size: 1.15rem;
  margin-bottom: 1.5em;

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
}

.pill {
  background-color: var(--g-color-primary);
  color: #fff;
  display: inline-flex;
  border-radius: 80px;
  padding: 0.65em 0.85em 0.7em;
  font-family: var(--g-font-body-family);
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  opacity: 0;

  @media (min-width: 768px) {
    font-size: 1.1rem;
  }
}
</style>
